import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Page from '../../services/api/page';
import { Row, Col, Collapse } from 'antd';
import ContasiscorpLogo from './img/contasis_logo.webp';
import ContasiscorpLogoMobile from './img/contasis_logo_mobile.webp';
import facebook from './img/facebook.png';
import whatsapp from './img/icono_whatsapp.webp';
import instagram from './img/instagram.png';
import linkedin from './img/linkedin.png';
import youtube from './img/youtube.png';
import tiktok from './img/tiktok.png';
import left from './img/left.png';
import libro_reclamos from './img/libro_reclamos.webp';
import Iso from './img/iso.png';
import Iso2 from './img/iso37001.png';


import defender from './img/defender.webp';
import candado from './img/candado.webp';

import './styles.scss';
const { Panel } = Collapse;
class Footer extends Component {
  render() {
    const producto_servico = (
      <div>
        <Col xs={24} sm={24} md={13} lg={13} xl={13}>
          <ul className="footer__menu footer__empresa">
            <li className="footer__menu--item menu--item01">
              <p className="footer__menu--title text--left">Empresas</p>
            </li>
            <li className="footer__menu--item menu--item_alt02">
              <a aria-label="Ver productos empresa" href="/empresa-digital?seccion=contableFinanciero">Contable Financiero</a>
            </li>
            <li className="footer__menu--item menu--item_alt02">
              <a aria-label="Ver productos empresa" href="/empresa-digital?seccion=comercialSQL">Comercial</a>
            </li>
            <li className="footer__menu--item menu--item_alt02">
              <a aria-label="Ver productos empresa" href="/empresa-digital?seccion=empresaRrhh">Recursos Humanos</a>
            </li>
            <li className="footer__menu--item menu--item_alt02">
              <a aria-label="Ver producto saf niif" href="/empresa-digital?seccion=safNiff">SAFNIIF</a>
            </li>
            <li className="footer__menu--item menu--item_alt02">
              <a aria-label="Más sobre producto facturación electronica" href="/empresa-digital?seccion=pseFacturacion">Facturación Electrónica PSE</a>
            </li>
            <li className="footer__menu--item menu--item_alt03">
              <a aria-label="Más sobre producto negocios online" href="/negocios-online">Negocios Online</a>
            </li>
          </ul>
        </Col>
        <Col xs={24} sm={24} md={11} lg={11} xl={11}>
          <ul className="footer__menu footer__contadores footer__top">
            <li className="footer__menu--item menu--item01">
              <p className="footer__menu--title text--left">Contadores</p>
            </li>            
            <li className="footer__menu--item menu--item_alt02">
              <a aria-label="Más sobre producto contadorsql" href="/contador-digital?seccion=contadorSQL">Contable</a>
            </li>
            <li className="footer__menu--item menu--item_alt02">
              <a aria-label="Más sobre producto inventariosql" href="/contador-digital?seccion=inventarioSQL">Inventario</a>
            </li>
            <li className="footer__menu--item menu--item_alt02">
              <a aria-label="Más sobre producto recursos humanos" href="/contador-digital?seccion=contadorRRHH">Recursos Humanos</a>
            </li>
            <li className="footer__menu--item menu--item_alt02">
              <a href="/contador-digital?seccion=activoFijo">Activo Fijo</a>
            </li>
            <li className="footer__menu--item menu--item_alt02">
              <a aria-label="Más sobre compliance" href="/contador-digital?seccion=infinito2">Darwin SIRE</a>
            </li>
            <li className="footer__menu--item menu--item_alt03">
              <a aria-label="Más sobre compliance" href="/contador-digital?seccion=infinito2">Compliance Tributario</a>
            </li>
          </ul>
        </Col>
      </div>
    );

    const nosotros = (
      <ul className="footer__menu">
        <li className="footer__menu--item menu--item01">
          <p className="footer__menu--title text--left ">#TeamContasis</p>
        </li>
        <li className="footer__menu--item menu--item_alt02">
          <a aria-label="Más sobre nosotros" href="/nosotros">Conócenos</a>
        </li>
        <li className="footer__menu--item menu--item_alt02">
          <b>Marca registrada - <br/>empresas asociadas:</b>
        </li>
        <li className="footer__menu--item menu--item_alt02">
          <a aria-label="Más sobre nosotros" href="https://www.videocontasis.com/imgcpartner/contasiscorp_landing/footer/CONTASISCORP%20MARCA.pdf" target="_blank" rel="noreferrer">Contasiscorp SAC</a>
        </li>
        <li className="footer__menu--item menu--item_alt02">
          <a aria-label="Más sobre nosotros" href="https://www.videocontasis.com/imgcpartner/contasiscorp_landing/footer/marcacontasisCERTIFICADO.pdf" target="_blank" rel="noreferrer">Contasis SAC</a>
        </li>
        <li className="footer__menu--item menu--item_alt02">
          <a aria-label="Más sobre nuestro signo distintivo" href="https://www.videocontasis.com/imgcpartner/contasiscorp_landing/footer/CONTASISCORP%20SIGNO%20D.pdf" target="_blank" rel="noreferrer">Signo distintivo</a>
        </li>
        <li className="footer__menu--item menu--item_alt02">
          <a aria-label="Más información de nuestra certificación compliance" href="https://www.videocontasis.com/imgcpartner/contasiscorp_landing/footer/COMPLIANCECERTIFICADO869914-2020.pdf" target="_blank" rel="noreferrer">Compliance</a>
        </li>
        <li className="footer__menu--item menu--item_alt02">
          <a aria-label="Más información de nuestra marca darwin" href="https://www.videocontasis.com/imgcpartner/contasiscorp_landing/footer/DARWIN%20MARCA.pdf" target="_blank" rel="noreferrer">Darwin</a>
        </li>
        <li className="footer__menu--item menu--item_alt02">
          <a aria-label="Más información de nuestro certificado" href="https://www.videocontasis.com/imgcpartner/contasiscorp_landing/footer/959307-2022-CERTIFICADO.pdf" target="_blank" rel="noreferrer">Negocios Online</a>
        </li>
        <li className="footer__menu--item menu--item_alt03">
          <a aria-label="Más información de nuestro certificado" href="https://www.videocontasis.com/imgcpartner/contasiscorp_landing/footer/registro_propiedad_industrial.pdf" target="_blank" rel="noreferrer">Mi Contasis</a>
        </li>
      </ul>
    );

    const servicio_cliente = (
      <ul className="footer__menu columna__5">
        <li className="footer__menu--item menu--item01">
          <p className="footer__menu--title text--left">
            <a
              aria-label="Contactanos por Whatsapp"
              href="https://api.whatsapp.com/send?phone=+51988553771&text=Necesito%20m%C3%A1s%20informaci%C3%B3n%20"
              target="_blank"
              rel="noreferrer"
            >
              <img loading="lazy" className="img-whatsapp" style={{ marginLeft: 0, marginRight: 4 }} src={whatsapp} alt="phone" />
              988 553 771
            </a>
          </p>
        </li>
        <li className="footer__menu--item menu--item_alt02">
          <a aria-label="Ingresa a nuestra plataforma" href={`${Page.constants.url_cuenta}/login`} target="_blank" rel="noreferrer">
            Mi Contasis
          </a>
        </li>
        {/* <li className="footer__menu--item">
          <a href="http://cpartner-contasiscorp.com/portal/vistas/login.html" target="_blank" rel="noreferrer">
            C - Partner
          </a>
        </li> */}
        <li className="footer__menu--item menu--item_alt02">
          <a aria-label="Más sobre nuestra academia" href="/academia-contasis" target="_blank" rel="noreferrer">
            Academia Contasis
          </a>
        </li>
        {/* <li className="footer__menu--item">
          <a href="https://www.certificacionemprendedor.com/curso-completo/-" target="_blank" rel="noreferrer">
            Certificación Emprendedor
          </a>
        </li> */}
        <li className="footer__menu--item menu--item_alt02">
          <a aria-label="Más de nuestras licencias" href="/servicio-cliente">Licenciamiento</a>
        </li>
        <li className="footer__menu--item menu--item_alt02">
          <a aria-label="Más información de pagos online" href="/pagaaqui">Pagos online</a>
        </li>
        <li className="footer__menu--item menu--item_alt02">
          <a aria-label="Más eventos" href="/eventos">Webinars</a>
        </li>
        <li className="footer__menu--item menu_renovaciones menu--item_alt02">
          <a aria-label="Más información de renovación de contadores" href="/renovacion-contadores">Renovación de licencias</a>
        </li>
        <li className="footer__menu--item menu--item_alt02">
          <a aria-label="Más información de cdpe" href="https://cdpe.contasiscorp.com/">Consulta tu Factura Electrónica</a>
        </li>
        <li className="footer__menu--item menu--item_alt02">
          <a aria-label="Más información de nuestra sostenibilidad" href="/sostenibilidad">Sostenibilidad</a>
        </li>
        <li className="footer__menu--item menu--item_alt03">
          <a aria-label="Más información de nuestra políticas-antisoborno" href="/politicas-antisoborno">Políticas Antisoborno</a>
        </li>        
      </ul>
    );

    return (
      <div className="contenedor-footer">
        <div className="contenedor footer">
          <Row>
            <Col xs={24} sm={24} md={5} lg={5} xl={5}>
              <div className="footer__logo" to="/">
                <img loading="lazy" className='web__1' src={ContasiscorpLogo} alt="Contasiscorp Logo" />
                <img loading="lazy" className='mobile__1' src={ContasiscorpLogoMobile} alt="Contasiscorp Logo" />
              </div>
              <p className="mejores__personas">Más de 20 años de evolución <br/>contable en la era digital.</p>
              <div className="web__1 footer__sociales">
                <div className='grupo_redes grupo01'>
                  <a aria-label="Mira nuestro facebook" href="https://www.facebook.com/contasiscorpperu/" target="_blank" alt="Facebook" rel="noreferrer">
                    <img loading="lazy" className='logo' src={facebook} alt='facebook'/>
                  </a>
                  <a
                    href="https://www.youtube.com/channel/UCXHEcpJot0yRXpkPe_Hl2QQ?view_as=subscriber"
                    target="_blank"
                    aria-label="Mira nuestro youtube"
                    rel="noreferrer"
                  >
                    <img loading="lazy" className='logo' src={youtube} />
                  </a>
                  <a aria-label="Mira nuestro linkedin" href="https://www.linkedin.com/company/contasiscorp-itc" target="_blank" alt="Linkedin" rel="noreferrer">
                    <img loading="lazy" className='logo' src={linkedin} alt='linkedin'/>
                  </a>
                </div>
                <div className='grupo_redes grupo02'>
                  <a aria-label="Mira nuestro instagram" href="https://www.instagram.com/contasis_?igsh=MWQyaXloNHlpenNyZQ==" target="_blank" alt="Instagram" rel="noreferrer">
                    <img loading="lazy" className='logo' src={instagram} alt='instagram'/>
                  </a>
                  <a aria-label="Mira nuestro tiktok" href="https://www.tiktok.com/@contasis_?_t=8njBIDx0CFa&_r=1" target="_blank" alt="Tiktok" rel="noreferrer">
                    <img loading="lazy" className='logo' src={tiktok} alt='tiktok'/>
                  </a>
                </div>                
              </div>
              <p className="mejores__somos">#SomosEvolución</p>
              <div className='ruc_empresa web__1'>
                RUC CONTASIS SAC<br/>
                20508997567
              </div>
            </Col>
            <Col xs={24} sm={24} md={8} lg={8} xl={8} className="producto__servico">
              <Collapse bordered={false} expandIconPosition="right" className="footer__collapse__responsive">
                <Panel
                  showArrow={false}
                  header={
                    <div className="footer__title" style={{ paddingBottom: 0 }}>
                      <span className="text--left">PRODUCTOS Y SERVICIOS</span>
                      <img loading="lazy" src={left} alt='left'/>
                    </div>
                  }
                  key="1"
                >
                  {producto_servico}
                </Panel>
                <Panel
                  showArrow={false}
                  header={
                    <div className="footer__title" style={{ paddingBottom: 0 }}>
                      <span className="text--left">SOBRE NOSOTROS</span>
                      <img loading="lazy" src={left} alt='left'/>
                    </div>
                  }
                  key="2"
                >
                  {nosotros}
                </Panel>
                <Panel
                  showArrow={false}
                  header={
                    <div className="footer__title" style={{ paddingBottom: 0 }}>
                      <span className="text--left">SERVICIO AL CLIENTE</span>
                      <img loading="lazy" src={left} alt='left'/>
                    </div>
                  }
                  key="3"
                >
                  {servicio_cliente}
                </Panel>
              </Collapse>

              <div className="footer__responsive footer__productos__servicios web__1">
                <div className="footer__title">
                  <span>PRODUCTOS Y SERVICIOS</span>
                </div>
                <Row className="footer__row">{producto_servico}</Row>
              </div>
            </Col>
            <Col xs={24} sm={24} md={3} lg={3} xl={3} className="producto__nosotros">
              <div className="footer__responsive footer__sobre__nosotros footer__row web__1">
                <div className="footer__title">
                  <span>SOBRE NOSOTROS</span>
                </div>
                {nosotros}
              </div>
            </Col>
            <Col xs={24} sm={24} md={3} lg={3} xl={3} className="producto__servicio_cliente">
              <div className="footer__responsive footer__servicio__cliente footer__row web__1">
                <div className="footer__title">
                  <span>SERVICIO AL CLIENTE</span>
                </div>
                {servicio_cliente}
              </div>
            </Col>
            <Col xs={24} sm={24} md={4} lg={4} xl={4} className="producto__ventas">
              <div className="footer__row fotter__ventas">
                <div className="footer__title">
                  <span>VENTAS</span>
                </div>
                <ul className="footer__menu">
                  <li className="footer__menu--item footer__telefono">
                    <p className="footer__menu--title footer_telefono text--left">
                      <a
                        href="https://api.whatsapp.com/send?phone=+51981428779&text=Necesito%20m%C3%A1s%20informaci%C3%B3n%20"
                        aria-label="Contactanos por Whatsapp"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img loading="lazy" className="img-whatsapp" style={{ marginLeft: 0, marginRight: 4 }} src={whatsapp} alt="phone" />
                        981 428 779
                      </a>
                    </p>
                  </li>
                  <li className="footer__menu--item footer__correo">
                    <Link to="#">ventas@contasiscorp.com</Link>
                  </li>
                  <div className="seguridad">
                    <div className="seguridad_img">
                      <img loading="lazy" className='iso_imagen' src={candado} alt='candado'/>
                    </div>
                    <div className="seguridad_texto">ENCRIPTACIÓN <br/>SSL PROTEGIDA</div>
                  </div>
                  <div className="seguridad2">
                    <div className="seguridad_img">
                      <img loading="lazy" className='iso_imagen' src={defender} alt='defender'/>
                    </div>
                    <div className="seguridad_texto">PAGO SEGURO <br/>GARANTIZADO</div>
                  </div>
                  <a aria-label="Acceso al libro de reclamaciones" className="libro_reclamos" href="/libro-reclamaciones" target="_blank">
                    <div className="seguridad_img">
                      <img loading="lazy" className='iso_imagen' src={libro_reclamos} alt='libro reclamos'/>
                    </div>
                    <div className="seguridad_texto">LIBRO DE <br/>RECLAMACIONES</div>
                  </a>
                  <a className="iso__cert iso__cert01" href="https://videocontasis.com/imgcpartner/contasiscorp_landing/footer/Certificato_n__CI_4714_del_14_02_2025.pdf" target="_blank" rel="noreferrer">
                    <div className="seguridad_img">
                      <img loading="lazy" className='iso_imagen' src={Iso} alt='iso'/>
                    </div>
                    <div className="seguridad_texto">CERTIFICADOS <br/>CON ISO 27001</div>
                  </a>
                  <a aria-label="Acceso al certificado iso 37001" className="iso__cert iso__cert02" href="https://www.videocontasis.com/imgcpartner/contasiscorp_landing/footer/Certificado%20ISO%2037001.pdf" target="_blank" rel="noreferrer">
                    <div className="seguridad_img">
                      <img loading="lazy" className='iso_imagen' src={Iso2} alt='iso 2'/>
                    </div>
                    <div className="seguridad_texto seguridad_texto_37001">CERTIFICADOS <br/>CON ISO 37001</div>
                  </a>
                </ul>
              </div>
              <div className="footer__sociales mobile__1">
                <div className='grupo_redes'>
                  <a aria-label="Mira nuestro facebook" href="https://www.facebook.com/contasiscorpperu/" target="_blank" alt="Facebook" rel="noreferrer">
                    <img loading="lazy" className='logo' src={facebook} alt='facebook'/>
                  </a>
                  <a
                    href="https://www.youtube.com/channel/UCXHEcpJot0yRXpkPe_Hl2QQ?view_as=subscriber"
                    target="_blank"
                    aria-label="Mira nuestro youtube"
                    rel="noreferrer"
                  >
                    <img loading="lazy" className='logo' src={youtube} alt='youtube'/>
                  </a>
                  <a aria-label="Mira nuestro linkedin" href="https://www.linkedin.com/company/contasiscorp-itc" target="_blank" alt="Linkedin" rel="noreferrer">
                    <img loading="lazy" className='logo' src={linkedin} alt='linkedin'/>
                  </a>
                  <a aria-label="Mira nuestro instagram" href="https://www.instagram.com/contasis_?igsh=MWQyaXloNHlpenNyZQ==" target="_blank" rel="noreferrer">
                    <img loading="lazy" className='logo' src={instagram} alt='instagram'/>
                  </a>
                  <a
                    href="https://www.tiktok.com/@contasis_?_t=8njBIDx0CFa&_r=1"
                    target="_blank"
                    aria-label="Mira nuestro tiktok"
                    rel="noreferrer"
                  >
                    <img loading="lazy" className='logo' src={tiktok} alt='tiktok'/>
                  </a>
                </div>                
              </div>
              <div className='ruc_empresa mobile__1'>
                RUC CONTASIS SAC<br/>
                20508997567
              </div>
            </Col>
          </Row>
        </div>
        <Row className="copyright-full">
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <div className="contenedor copyright">
              <p className="web__1">Edificio Platinium - Calle Dean Valdivia 148 San Isidro (01) 711 8492</p>
              <p>Copyright © 2004 - 2025 <span className='mobile__1'></span>Contasiscorp ® Contasis ®</p>
              <a href='/politicas-privacidad' className="flex__start link_privacidad">
                <div style={{ paddingRight: 12 }}>Politicas de Privacidad</div>
                <div className="border__left">Términos y Condiciones</div>
              </a>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Footer;
